<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <ng-container formGroupName="loan">
                <div formArrayName="insuranceQuotite">
                  @for (
                    quotite of insuranceQuotite.controls;
                    track quotite;
                    let i = $index
                  ) {
                    <div class="quotite-container mt-1" [formGroupName]="i">
                      <pr-input-owner
                        formControlName="ownerId"
                        [multiple]="false"
                        [derrors]="derrors"
                      ></pr-input-owner>
                      <pr-input label="Quotité" suffix="%" [derrors]="derrors">
                        <input formControlName="quotite" type="text" />
                      </pr-input>
                      <pr-input-radio
                        [toggleBgEmpty]="true"
                        formControlName="assureLemoineDetails"
                        clazz="input-radio-lemoine"
                        class="input-radio-lemoine"
                        label="Cadre loi lemoine : L'assuré est-il déjà couvert sur un ou plusieurs autres prêts immobiliers pour un montant supérieur ou égal à 200 000€ projet actuel compris ? (Somme des capitaux restant dus des prêts immobiliers en cours en tenant compte de la quotité assurée)"
                        [options]="[
                          {
                            value: 'INF_EGAL_200K',
                            label: 'Inférieur ou égal à 200 000€',
                          },
                          {
                            value: 'SUP_200K',
                            label: 'Supérieur à 200 000€',
                          },
                        ]"
                      >
                      </pr-input-radio>
                      @if (
                        quotite.get('assureLemoineDetails').value ===
                          'INF_EGAL_200K' &&
                        product
                          ?.get('parameters')
                          .get('borrowerInsuranceContext').value === 'CHANGE'
                      ) {
                        <pr-input-radio
                          formControlName="repriseGroupe"
                          columns="3"
                          [toggle]="true"
                          [isDefault]="false"
                          label="Le contrat à substituer est-il actuellement couvert par le contrat groupe de la Banque ?"
                        >
                        </pr-input-radio>
                      }
                      <pr-button
                        variant="outline"
                        display="danger"
                        label="Supprimer"
                        (click)="removeInsuranceQuotite(i)"
                      />
                    </div>
                  }
                  <pr-button
                    display="neutral"
                    variant="outline"
                    clazz="mt-1"
                    label="+ Ajouter une quotité"
                    (click)="addInsuranceQuotite()"
                  />
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
